import { useEffect, useState } from 'react';
import { HolidayType } from '../components/Holidays/graphql';
import { useSchoolYearsQuery } from '../types/planung-graphql-client-defs';
import { useMemorizedCacheTag } from './useMemorizedCacheTag';
import { useSelectedSchoolYear } from './useSelectedSchoolYear';

export const useGetHolidays = () => {
  const context = useMemorizedCacheTag('SCHOOL_YEAR');
  const selectedSchoolYear = useSelectedSchoolYear();

  const [holidays, setHolidays] = useState<HolidayType[] | null>(null);

  const [{ data }] = useSchoolYearsQuery({
    context: context,
  });

  useEffect(() => {
    const year = data ? data.schoolYears.find((year) => year.uuid === selectedSchoolYear?.uuid) : null;
    setHolidays(year ? year.holidays : null);
  }, [selectedSchoolYear, data]);

  return { holidays, schoolYear: selectedSchoolYear };
};
